import React, { useEffect, useState } from 'react';
export function IntroPreloader() {
  const [isVisible, setIsVisible] = useState(true);
  const [isExiting, setIsExiting] = useState(false);
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const exitTimer = window.setTimeout(() => setIsExiting(true), 2500);
    const removeTimer = window.setTimeout(() => {
      document.body.style.overflow = previousOverflow;
      setIsVisible(false);
    }, 3000);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.clearTimeout(exitTimer);
      window.clearTimeout(removeTimer);
    };
  }, []);
  if (!isVisible) return null;
  return <div className={`intro-preloader${isExiting ? ' intro-preloader--exiting' : ''}`} aria-hidden="true" data-id="element-167">
      <div className="intro-preloader__content" data-id="element-168">
        <div className="intro-preloader__candle" data-id="element-169">
          <div className="intro-preloader__flame-shell" data-id="element-170">
            <div className="intro-preloader__flame" data-id="element-171" />
          </div>
          <div className="intro-preloader__smoke" data-id="element-172" />
          <div className="intro-preloader__wick" data-id="element-173" />
          <div className="intro-preloader__body" data-id="element-174" />
        </div>
        <p className="intro-preloader__wordmark" data-id="element-175">SAVIA</p>
      </div>
    </div>;
}